import { buildTestIds } from "application";
import { theme } from "ui";
import { PixPaymentProps } from "../../PaymentMethods.types";
import * as PixPaymentSub from "./PixPayment.styles";

const PixPayment = ({ discount = 0, price = 0 }: PixPaymentProps) => {
  const formatedPrice = price.toLocaleString("pt-br", {
    style: "currency",
    currency: "BRL",
  });
  return (
    <PixPaymentSub.Container {...buildTestIds("pix-payment-container")}>
      <PixPaymentSub.Indicator {...buildTestIds("pix-payment-indicator")}>
        <PixPaymentSub.Title {...buildTestIds("pix-payment-title")}>
          Pix
        </PixPaymentSub.Title>
        <PixPaymentSub.Icon width={theme.space.x6} height={theme.space.x6} />
      </PixPaymentSub.Indicator>
      <PixPaymentSub.Info {...buildTestIds("pix-payment-info")}>
        <PixPaymentSub.Label {...buildTestIds("pix-payment-label")}>
          {`Pague no PIX ${discount ? "com desconto" : ""}`}
        </PixPaymentSub.Label>
        <PixPaymentSub.Price {...buildTestIds("pix-payment-price")}>
          {formatedPrice} {discount ? `(${discount}% de desconto)` : ""}
        </PixPaymentSub.Price>
      </PixPaymentSub.Info>
    </PixPaymentSub.Container>
  );
};

export default PixPayment;
